var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "281px",
    height: "183px",
    viewBox: "0 0 281 183",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 261,
    height: 163,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.2%",
    y: "-8.3%",
    width: "112.6%",
    height: "120.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-13--Actions",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.10--LegalSite-customization",
    transform: "translate(-1084.000000, -248.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(149.000000, 146.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(942.000000, 109.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "title",
    transform: "translate(18.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Name",
    fontFamily: "Helvetica",
    fontSize: 14,
    fontWeight: "normal",
    "line-spacing": 19,
    fill: "#969696"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "Subtitle 2")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#DFE4EE",
    fill: "#EBA601",
    x: 0.5,
    y: 30.5,
    width: 37,
    height: 37,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "field",
    transform: "translate(0.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#B0BAC9",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 222,
    height: 37,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u21B3-\\u270F\\uFE0F-Value",
    fontFamily: "Helvetica",
    fontSize: 14,
    fontWeight: "normal",
    "line-spacing": 26,
    fill: "#B0BAC9"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 20
  }, "Font")), /*#__PURE__*/React.createElement("g", {
    id: "expand-more",
    opacity: 0.54,
    transform: "translate(197.000000, 15.000000)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "10.6 0.599975586 6 5.19997559 1.4 0.599975586 0 1.99997559 6 7.99997559 12 1.99997559"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "field",
    transform: "translate(62.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#B0BAC9",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 72,
    height: 37,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u21B3-\\u270F\\uFE0F-Value",
    fontFamily: "Helvetica",
    fontSize: 14,
    fontWeight: "normal",
    "line-spacing": 26,
    fill: "#B0BAC9"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 20
  }, "40")), /*#__PURE__*/React.createElement("g", {
    id: "expand-more",
    opacity: 0.54,
    transform: "translate(55.000000, 15.000000)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "10.6 0.599975586 6 5.19997559 1.4 0.599975586 0 1.99997559 6 7.99997559 12 1.99997559"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4);
export default __webpack_public_path__ + "static/media/Group 4.ce511749d748ac26271b7053dc264fea.svg";
export { ForwardRef as ReactComponent };